export default __webpack_public_path__ + "static/media/sensotrend_signin_set_pwd.ace18674.png";